// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3hCmS","inner":"Footer_inner__2f8rL"};